import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

const NRTFormErrorMsg = (props) =>
    <div className='nrt-form-error-msg'>
        {props.children || props.msg}
    </div>


NRTFormErrorMsg.propTypes = {
    msg: PropTypes.any,
}

NRTFormErrorMsg.defaultProps = {}

export default NRTFormErrorMsg



// WEBPACK FOOTER //
// ./src/components/_common/_form/FormErrorMsg/index.js